module.exports = __webpack_public_path__ + "static/img/u2551.1ff3276.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/u2551.png
// module id = Cmeu
// module chunks = 1